import { ReactComponent as IconMenuProject } from "assets/images/icons/icon-menu-project.svg"
import { ReactComponent as IconMenuConversation } from "assets/images/icons/icon-menu-conversation.svg"
import { ReactComponent as IconMenuSetting } from "assets/images/icons/icon-meu-setting.svg"
import { ReactComponent as IconMenuBuildOverview } from "assets/images/icons/icon-menu-build.svg"
import { ReactComponent as IconAddressBook } from "assets/images/icons/address-book.svg"
import { ReactComponent as IconActionLog } from "assets/images/icons/menu-activity.svg"
import { ReactComponent as IconSyncCommitComponent } from "assets/images/icons/programming-arrow.svg"
import { ReactComponent as IconMenuGroup } from "assets/images/icons/group-project.svg"
import { ReactComponent as IconMenuUserGroup } from "assets/images/icons/profile-2user.svg"
import { ReactComponent as IconMyAccess } from "assets/images/icons/my-access.svg"

import { MenuLeftProps } from "./types"
import { PATH } from "constants/path"

export const MENU_LEFT: MenuLeftProps[] = [
  {
    name: "Projects",
    icon: IconMenuProject,
    path: PATH.projects,
  },
  {
    name: "Builds",
    icon: IconMenuBuildOverview,
    path: PATH.defaultBuildOverview,
  },
  {
    name: "Address book",
    icon: IconAddressBook,
    path: PATH.addressBook,
  },
  {
    name: "Settings",
    icon: IconMenuSetting,
    path: PATH.workspaceSetting,
  },
]

export const MENU_LETF_SYNC_COMMIT_COMPONENT = {
  name: "Sync histories",
  icon: IconSyncCommitComponent,
  path: PATH.syncCommitComponent,
}

export const MENU_LEFT_CONVERSATIONS = {
  name: "Conversations",
  icon: IconMenuConversation,
  path: PATH.conversations,
}

export const MENU_LEFT_ACTION_LOGS = {
  name: "Action logs",
  icon: IconActionLog,
  path: PATH.actionLog,
}

export const MENU_LEFT_MY_ACCESS = {
  name: "My Access",
  icon: IconMyAccess,
  path: PATH.assignment,
}

export const MENU_LEFT_USER_GROUPS = {
  name: "Users & Groups",
  icon: IconMenuUserGroup,
  path: PATH.userGroups,
}
